import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactElement } from "react";
import { toast } from "react-hot-toast";
import { newRightArrowIcon } from "../../constant";
import { colors } from "../../styles/design-tokens";

// const InfoIconComponent = (): ReactElement => <InfoOutlinedIcon sx={{ color: colors.neutral.white }} />;

const SuccessIconComponent = (): ReactElement => (
  <CheckCircleOutlineIcon sx={{ color: colors.neutral.white, width: 30, height: 30 }} />
);

// const CloseIconComponent = (): ReactElement => (
//   <CancelOutlinedIcon
//     sx={{ color: colors.neutral.white, width: 18, height: 18, cursor: "pointer" }}
//     onClick={() => toast.dismiss()}
//   />
// );

let currentToastId: string | null = null;

export const toastMessage = {
  success: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          maxWidth: "calc(100vw - 48px)",
          position: "relative",
          whiteSpace: "pre-line",
        }}
        onClick={() => toast.dismiss()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: "12px", /* Figma audit: 12px gap */
          }}
        >
          <div>
            <CheckOutlinedIcon
              style={{
                width: "24px",
                height: "24px",
              }}
              htmlColor="#34C759"
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: "500", /* Figma audit: fontWeight not fontStyle */
                color: "#34C759",
                fontSize: "16px", /* Figma audit: 16px */
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                marginTop: "3px",
              }}
            >
              {message}
            </div>
            <div
              style={{
                fontWeight: "500", /* Figma audit: fontWeight not fontStyle */
                color: "#34C759",
                fontSize: "16px", /* Figma audit: 16px */
              }}
            >
              {detailedMessage}
            </div>
          </div>
        </div>
      </div>,
      {
        duration: 3000,
        // icon: InfoIconComponent(),
        style: {
          backgroundColor: "#ebf9ee",
          borderRadius: "8px",
          padding: "12px",
          width: "100%",
          boxShadow: "none",
          border: "none",
          outline: "none",
          margin: "0px",
        },
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },
  newSuccess: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          position: "relative",
          whiteSpace: "pre-line",
          marginLeft: "-10px",
          marginRight: "-10px",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            color: "#fffff",
            fontSize: "12px",
            letterSpacing: "0.3px",
            marginLeft: "10px",
          }}
        >
          {message || "SUCCESS"}
        </div>
        <div
          style={{
            fontStyle: "500",
            color: colors.neutral.white,
            fontSize: "10px",
            letterSpacing: "0.2px",
            marginLeft: "10px",
          }}
        >
          {detailedMessage}
        </div>
      </div>,
      {
        icon: SuccessIconComponent(),
        style: {
          background: "linear-gradient(180deg, rgba(124, 190, 234, 1) 0%, rgba(9, 90, 139, 1) 100%)",
          borderRadius: "6px",
          border: "1.1px solid rgba(255, 255, 255, 1)",
          color: colors.neutral.white,
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
        },
        duration: 3000,
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },
  selectSuccess: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          position: "relative",
          whiteSpace: "pre-line",
          marginLeft: "-80px",
          marginRight: "-10px",
        }}
      >
        <div
          style={{
            fontFamily: "var(--brand-font-body)",
            fontWeight: "500",
            color: colors.neutral.white,
            fontSize: "10px",
            letterSpacing: "0.3px",
            marginLeft: "10px",
          }}
        >
          {message || "SUCCESS"}
        </div>
        <div
          style={{
            fontFamily: "var(--brand-font-body)",
            fontWeight: "600", /* Figma audit: fontWeight not fontStyle */
            fontSize: "10px",
            letterSpacing: "0.2px",
            marginLeft: "10px",
            color: colors.neutral.white,
          }}
        >
          {detailedMessage}
        </div>
      </div>,
      {
        icon: <img src={newRightArrowIcon} alt="" style={{ width: "26px", height: "26px" }} />,
        style: {
          background: "#1B75BA",
          borderRadius: "6px",
          border: "1.1px solid rgba(255, 255, 255, 1)",
          color: colors.neutral.white,
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
          minWidth: "300px",
        },
        duration: 5000,
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 5000);
  },
  error: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          maxWidth: "calc(100vw - 48px)",
          position: "relative",
          whiteSpace: "pre-line",
        }}
        onClick={() => toast.dismiss()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: "12px", /* Figma audit: 12px gap */
          }}
        >
          <div>
            <CloseOutlinedIcon
              style={{
                width: "24px",
                height: "24px",
              }}
              htmlColor="#FF3B30"
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: "500", /* Figma audit: fontWeight not fontStyle */
                color: "#FF3B30",
                fontSize: "16px", /* Figma audit: 16px */
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                marginTop: "3px",
              }}
            >
              {message}
            </div>
            <div
              style={{
                fontWeight: "500", /* Figma audit: fontWeight not fontStyle */
                color: "#FF3B30",
                fontSize: "16px", /* Figma audit: 16px */
              }}
            >
              {detailedMessage}
            </div>
          </div>
        </div>
      </div>,
      {
        duration: 3000,
        // icon: InfoIconComponent(),
        style: {
          backgroundColor: "#ffebea",
          borderRadius: "8px",
          padding: "12px",
          width: "100%",
          boxShadow: "none",
          border: "none",
          outline: "none",
          margin: "0px",
        },
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },

  loading: (message: string) => {
    if (!message) return;
    toastMessage.success(message);
  },
  info: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          maxWidth: "calc(100vw - 48px)",
          position: "relative",
          whiteSpace: "pre-line",
        }}
        onClick={() => toast.dismiss()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: "12px", /* Figma audit: 12px gap */
          }}
        >
          <div>
            <InfoOutlinedIcon
              style={{
                width: "24px",
                height: "24px",
              }}
              htmlColor="#007AFF"
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: "500", /* Figma audit: fontWeight not fontStyle */
                color: "#007AFF",
                fontSize: "16px", /* Figma audit: 16px */
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                marginTop: "3px",
              }}
            >
              {message}
            </div>
            <div
              style={{
                fontWeight: "500", /* Figma audit: fontWeight not fontStyle */
                color: "#007AFF",
                fontSize: "16px", /* Figma audit: 16px */
              }}
            >
              {detailedMessage}
            </div>
          </div>
        </div>
      </div>,
      {
        duration: 3000,
        // icon: InfoIconComponent(),
        style: {
          backgroundColor: "#e5f2ff",
          borderRadius: "8px",
          padding: "12px",
          width: "100%",
          boxShadow: "none",
          border: "none",
          outline: "none",
          margin: "0px",
        },
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },
};
